module.exports = __webpack_public_path__ + "assets/img/gold_icon.d0d3b095.png";